// extracted by mini-css-extract-plugin
export var searchHeader = "_4g-0";
export var searchHeaderDark = "_4g-1";